/*
    This file contains the text for the educator page.
    The text is in two languages, English and Arabic.
    Every language has a list with the paragraphs for the main text.
    Every text block must be enclodes between two double quotes (") or two single quotes ('). 
    If you want to use a double quote or a single quote inside the text, put a backslash (\) before the quote, like this: \" or \'.
    Every paragraph must be separated by a comma (,).
    Every list of paragraphs must be enclosed by square brackets ([]).
    If you want to make a new line without starting a new paragraph, use the \n. Do not use enter, it will break the paragraph.
    If you want to make a piece of text bold, use the ** before and after the text you want to make bold, like this: **bold text**.
    If you want put a bullet point, use the ● (or any ASCII character) before the text you want to make a bullet point, like this: ● bullet point.
*/

export const educator = {
    english: {
        text: [
            "**Hello!**",
            "Are you a graphic design educator looking to explore bilingual books using Arabic and Latin scripts with your students? This PDF offers several assignments to help you do just that!",
            "Inside, you’ll find:",
            "• General descriptions of each assignment.",
            "• Step-by-step instructions.",
            "• Thought-provoking questions that help in class discussions.",
            "• Typesetting tips to guide students through the process.",
            "To get started, you can use sample texts from either the landing page or the interviews page of this website.",
            "As a starter, this package includes five assignments designed to help students understand the possibilities and challenges of designing with two scripts that run in opposite directions. These exercises encourage experimentation and thoughtful design choices, offering a hands-on approach to exploring bi-scriptal book formats. ",
            "This platform serves as a visual aid, helping grasp the decisions they need to make when working with scripts that read in opposite directions.",
            "It’s important to note that text in any of the scripts can be typographically composed in endless ways.",
            "—",

        ]
    },
    arabic: {
        text: [
            "**مرحبًا!**",
"هل أنت مُدرس تصميم جرافيكي تبحث عن استكشاف كتب ثنائية اللغة باستخدام الخطين العربي واللاتيني مع طلابك؟ يوفر ملف الـ PDF المرفق عدة مهام لمساعدتك.",
"داخل الملف، ستجد:",
"• أوصاف عامة لكل مهمة.",
" • تعليمات خطوة بخطوة.",
" • أسئلة محفّزة للتفكير ولدفع النقاش في الصف.",
" • نصائح في تنضيد النص لإرشاد الطلاب خلال العمل.",
"للبدء، يمكنك استخدام نصوص نموذجية من الصفحة الرئيسية أو صفحة المقابلات على هذا الموقع.",
"كخطوة أولى، تحتوي هذه الحزمة على خمس تمارين مصممة لمساعدة الطلاب على فهم إمكانيات وتحديات التصميم الذي يستخدم نصّان يقرآن في اتجاهين متعاكسين. تشجّع هذه التمارين على التجريب واتخاذ قرارات تصميم مدروسة، مقدمة نهجًا عمليًا لاستكشاف هياكل كتب ثنائية الكتابة.",
"تعمل هذه المنصة كأداة بصرية تساعد على فهم القرارات التي يجب اتخاذها عند العمل مع خطوط تُقرأ في اتجاهين مختلفين.",
"يجدر التنويه بأن النصوص في أي من الخطين يمكن تصميمها تيبوغرافيًا بطرق غير محدودة.",
"—",
        ]
    }
}